function isUnstableInAppBrowser() {
  const ua = navigator.userAgent || '';
  const knownFlaky = /Instagram|FBAN|FBAV|FB_IAB|TikTok|Line\//i.test(ua);
  // Fallback: catches in-app/webview browsers whose UA doesn't
  // self-identify (e.g. some Instagram builds), plus any coarse-pointer
  // (touch) device, since smooth-scroll libs add little value there
  // and are the actual source of the flicker risk.
  const looksLikeWebview = !window.chrome && /iPhone|Android/i.test(ua) && !('standalone' in navigator);
  const isTouchDevice = matchMedia('(pointer: coarse)').matches;
  return knownFlaky || looksLikeWebview || isTouchDevice;
}

const lenis = isUnstableInAppBrowser()
  ? { on: () => {}, stop: () => {}, start: () => {}, raf: () => {} } // no-op stub
  : new Lenis({
      smoothWheel: true,
      smoothTouch: false,
      normalizeWheel: true,
      ignore: el => el.classList.contains("scroll-section")
    });

if (!isUnstableInAppBrowser()) {
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add(time => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);
}

const toggleButtons = document.querySelectorAll(".toggle-btn-d")
  , mainHeader = document.querySelector(".main-header");
toggleButtons.forEach(button => {
    button.addEventListener("click", () => {
        const targetClass = button.getAttribute("data-target")
          , targetMenu = document.querySelector(`.${targetClass}`);
        button.classList.toggle("active"),
        targetMenu.classList.toggle("active"),
        targetMenu.classList.contains("active") && mainHeader.classList.remove("to-transform"),
        (targetClass === "desk-menu-box" || targetClass === "mob-menu-box") && (targetMenu.classList.contains("active") ? lenis.stop() : lenis.start())
    }
    )
}
);
const deskMenuBox = document.querySelector(".desk-menu-box");
deskMenuBox && deskMenuBox.addEventListener("click", e => {
    if (e.target === deskMenuBox) {
        deskMenuBox.classList.remove("active");
        const button = document.querySelector('.toggle-btn-d[data-target="desk-menu-box"]');
        button && button.classList.remove("active"),
        mainHeader && mainHeader.classList.remove("to-transform"),
        lenis.start()
    }
}
);
const mobMenuBox = document.querySelector(".mob-menu-box");
mobMenuBox && mobMenuBox.addEventListener("click", e => {
    if (e.target === mobMenuBox) {
        mobMenuBox.classList.remove("active");
        const button = document.querySelector('.toggle-btn-d[data-target="mob-menu-box"]');
        button && button.classList.remove("active"),
        mainHeader && mainHeader.classList.remove("to-transform"),
        lenis.start()
    }
}
);

function initAllSwipers(scope = document) {
  if (typeof Swiper === "undefined") return;

  scope.querySelectorAll(".swiper-container:not(.swiper-initialized)").forEach((container) => {
    // Skip any swiper inside .cust-recom
    if (container.closest(".cust-recom")) return;

    new Swiper(container, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initAllSwipers();

  // Watch for any native product-recommendations block that loads its cards later
  document.querySelectorAll("product-recommendations").forEach((block) => {
    const observer = new MutationObserver(() => initAllSwipers(block));
    observer.observe(block, { childList: true, subtree: true });
  });
});

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", e => {
        const accordion = e.target.closest(".pdp-accordion-main");
        if (!accordion)
            return;
        const tab = e.target.closest(".accordion-title li");
        if (!tab)
            return;
        const tabs = accordion.querySelectorAll(".accordion-title li")
          , contents = accordion.querySelectorAll(".accordion-content")
          , target = tab.dataset.tab;
        tabs.forEach(t => t.classList.toggle("active", t === tab)),
        contents.forEach(c => c.classList.toggle("active", c.dataset.content === target))
    }
    )
}
)



document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".cust-collection-page2");
  if (!wrapper) return;

  const options = wrapper.querySelectorAll("#grid-options li[data-columns]");

  // Set default on load — change 4 to whatever your default col count is
  const defaultCols = 4;
  wrapper.classList.add(`cols-${defaultCols}`);
  options.forEach((o) => {
    if (parseInt(o.dataset.columns, 10) === defaultCols) o.classList.add("active");
  });

  options.forEach((option) => {
    option.addEventListener("click", () => {
      const cols = parseInt(option.dataset.columns, 10);

      options.forEach((o) => o.classList.remove("active"));
      option.classList.add("active");

      wrapper.classList.remove("cols-1","cols-2","cols-3","cols-4","cols-5","cols-6");
      wrapper.classList.add(`cols-${cols}`);
    });
  });
});

// === Stock-aware quantity guard for cart drawer ===
// Blocks the + button before Shopify's own QuantityInput handler runs,
// by intercepting the click in the capture phase.
document.addEventListener('click', function (event) {
  const plusBtn = event.target.closest('.quantity__button[name="plus"]');
  if (!plusBtn) return;

  const wrapper = plusBtn.closest('quantity-input');
  if (!wrapper) return;

  const input = wrapper.querySelector('.quantity__input');
  if (!input) return;

  const managed = input.dataset.inventoryManagement; // "shopify" if tracked, "" if not
  const policy = input.dataset.inventoryPolicy;       // "deny" or "continue"
  const stock = parseInt(input.dataset.inventoryQuantity, 10);
  const current = parseInt(input.value, 10) || 0;

  // Only enforce a cap if inventory is actually tracked AND overselling isn't allowed
  if (managed !== 'shopify' || policy !== 'deny') return;

  if (current >= stock) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const row = wrapper.closest('.cart-item');
    const errorBox = row?.querySelector('.cart-item__error');
    const errorText = errorBox?.querySelector('.cart-item__error-text');
    if (errorText) {
      errorText.textContent = stock <= 0
        ? 'This item is out of stock.'
        : `Only ${stock} left in stock.`;
      errorBox.style.display = 'flex';

      // auto-hide after 3s, matches theme's existing error style
      clearTimeout(errorBox._hideTimeout);
      errorBox._hideTimeout = setTimeout(() => {
        errorBox.style.display = 'none';
      }, 3000);
    }
  }
}, true); // <-- capture: true is what lets us intercept before QuantityInput's own listener

// === Global pinch/zoom guard =====================================
// Whenever 2+ fingers touch the screen, treat it as native pinch-zoom
// and pause every custom touch/animation system until it ends.
(function () {

    const ua = navigator.userAgent || "";

    const isMetaBrowser =
        /Instagram|FBAN|FBAV|FB_IAB/i.test(ua);

    if (!isMetaBrowser) return;

    document.documentElement.classList.add("meta-browser");

    let pinching = false;

    function pauseEffects() {

        if (pinching) return;

        pinching = true;

        document.documentElement.classList.add("is-pinching");

        if (window.lenis && typeof lenis.stop === "function") {
            lenis.stop();
        }

        if (window.gsap && gsap.ticker) {
            gsap.ticker.sleep();
        }

    }

    function resumeEffects() {

        if (!pinching) return;

        pinching = false;

        document.documentElement.classList.remove("is-pinching");

        if (window.lenis && typeof lenis.start === "function") {
            lenis.start();
        }

        if (window.gsap && gsap.ticker) {
            gsap.ticker.wake();
        }

        if (window.ScrollTrigger) {
            ScrollTrigger.refresh();
        }

    }

    document.addEventListener("touchstart", e => {

        if (e.touches.length > 1) {
            pauseEffects();
        }

    }, {
        passive: true,
        capture: true
    });

    document.addEventListener("touchmove", e => {

        if (e.touches.length > 1) {
            pauseEffects();
        }

    }, {
        passive: true,
        capture: true
    });

    document.addEventListener("touchend", e => {

        if (e.touches.length < 2) {
            resumeEffects();
        }

    }, {
        passive: true,
        capture: true
    });

    document.addEventListener("touchcancel", resumeEffects, {
        passive: true,
        capture: true
    });

})();